import React from 'react';
import './KodanshaResume.scss';
import KodanshaPoster from '../KodanshaPoster/KodanshaPoster';
import KodanshaProgressBar from '../KodanshaProgressBar/KodanshaProgressBar';
import ProductPoster from '../ProductPoster/ProductPoster';
import apiClient from '../../../API/InkyAPI';
import { Product } from '../../../Models/Product';
import { useHistory } from 'react-router-dom';
import { Link } from '../../../Devon/Components/InkyLink';
import { readerReadableUrlOrDefault } from '../../../utils/utils';

interface Props {
    isVolumePass?: boolean;
    isNew?: boolean;
    chapterOnly?: boolean;
    isChapter?: boolean;
    readingProgress?: number;
    chapterName?: string;
    chapterNumber?: number;
    volumeNumber?: number;
    src?: string;
    id?: number;
    seriesId?: number;
    productType?: string | 'Volume' | 'Chapter';
    readableUrl:string;
    seriesReadableUrl:string;
    readerLink: string;
}


const KodanshaResume = ({
                            isNew = false,
                            chapterOnly = false,
                            isVolumePass = false,
                            readingProgress = 0,
                            src = '',
                            chapterName = '',
                            chapterNumber = null,
                            volumeNumber,
                            id = null,
                            seriesId,
                            isChapter = false,
                            productType = 'Volume',
                            readableUrl,
                            readerLink,
                            seriesReadableUrl,

                        }: Props): JSX.Element => {
    const history = useHistory();

    const onNameClicked = (e) => {
        e.stopPropagation();
        // if (isChapter) {
        //     history.push('/product/' + volumeNumber.toString());
        //     return;
        // }
        if (seriesId) {
            history.push('/series/' + seriesId.toString());
            return;
        }
        history.push('/product/' + id.toString());
    };

    return (
        <Link to={{ pathname: readerLink, state: { returnPath: history.location.pathname } }}
              className='cm-resume-container'
        >
            <ProductPoster src={src} alt={src} ratio={140} />

            <div className='right-column'>
                <Link to={seriesId ? '/series/' + seriesReadableUrl : '/product/' + readableUrl}
                      className='chapter-name'
                      aria-label={'resume title ' + chapterName}>
                    {chapterName}
                </Link>
                {!chapterOnly && <div className='volume-chapter-number-wrapper'>
                    <div className='remove-window-size-wrapper'>
                        <Link to={seriesId ? '/series/' + seriesReadableUrl : '/product/' + readableUrl}
                              className='chapter-number' aria-label={'volume number ' + volumeNumber}>
                            {productType === 'Volume' ? `Volume ${volumeNumber}` : `Volume ${volumeNumber}:`}
                        </Link>

                        {productType === 'Chapter' &&
                            <Link to={seriesId ? '/series/' + seriesReadableUrl : '/product/' + readableUrl}
                                  aria-label={'chapter number ' + chapterNumber} className='chapter-number-2'>
                                Chapter {chapterNumber}
                            </Link>}
                    </div>

                    <span onClick={onNameClicked}
                          aria-label={'Volume' + volumeNumber}
                          className='chapter-number-window-size'>
                        {productType === 'Volume' ? `Volume ${volumeNumber}` : `Chapter ${chapterNumber}`}
                    </span>


                </div>}


                {chapterOnly && <div className='volume-chapter-number-wrapper'>
                            <span className='chapter-number' aria-label={'chapter number ' + chapterNumber}
                                  onClick={onNameClicked}>
                                Chapter {chapterNumber}
                            </span>
                </div>}

                <KodanshaProgressBar fill={readingProgress ?? 0} />
            </div>

            <div className='is-new-wrapper'>
                {isVolumePass && <span className='volume-pass'>VOLUME PASS</span>}
                {isNew && <span className='is-new'>NEW</span>}
            </div>
        </Link>
    );
};

export default KodanshaResume;
